import React from 'react';

const variantClassMap = {
    primary: 'msds-btn--primary',
    secondary: 'msds-btn--secondary',
    tertiary: 'msds-btn--tertiary',
};

function Button(props: ButtonProps) {
    const { color, type, children, onClick, ...otherProps } = props;

    const variantClass = variantClassMap[color] ?? '';
    const classes = `msds-btn ${variantClass}`;
    const buttonType = type ?? 'button';
    const { className, ...filteredOtherProps } = otherProps;

    return (
        <button
            formNoValidate = {true}
            type={buttonType}
            className={`${classes} ${className}`}
            onClick={onClick}
            {...filteredOtherProps}
        >
            {children}
        </button>
    );
}

type ButtonProps = {
    color?: 'primary' | 'secondary' | 'tertiary';
    type?: 'submit' | 'button' | 'reset';
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    children: React.ReactNode;
    [otherProps: string]: unknown;
};

export default Button;
